import SearchEmail from './SearchEmail';
import EmailResults from './EmailResults';
import EmailInfo from './EmailInfo';
import { VIEWS } from '../../../utils/emailUtils';
const { MODAL } = VIEWS;

export default class EmailData extends React.Component {
    state = { view: null }
    constructor(props) { super(props); }

    changeView = v => this.setState({...this.state, view: v });

    componentDidMount() {
        const { services, role } = this.props;
        if(role === 'admin') services.getEmailTypes();
        else services.getEmailTypesByRole(role);
    }

    render() {
        const
        { view } = this.state,
        { state, session, services, role, searchFields, endorsementId, userSchools } = this.props,
        { messageTypes, schools, emailList, email, searchingMessages, pagination, values } = state,
        searchEmails = {
            messageTypes,
            session,
            services,
            schools,
            role,
            searchFields,
            userSchools,
            endorsementId,
            pagination
        },
        emailResults = {
            services,
            role,
            searchingMessages: searchingMessages == true,
            table: emailList,
            controls: { changeView: this.changeView },
            pagination,
            values
        },
        emailDetails = {
            services: services,
            emailInfo: email,
            controls: { changeView: this.changeView }
        };

        switch(view) {
            case MODAL: return (
                <div>
                    <SearchEmail {...searchEmails} />
                    <EmailResults {...emailResults} />
                    <EmailInfo {...emailDetails} />
                </div>
            );
            default: return (
                <div>
                    <SearchEmail {...searchEmails} />
                    <EmailResults {...emailResults} />
                </div>
            );
        }
    }
}
